const correctionSettlementOrderReasonTypes = {
	NEGATIVE_AMOUNT_BOOTH_OWNER_ACCOUNT: 'negativeAmountBoothOwnerAccount',
	MANUAL: 'manual',
	PAYOUT_BANK_REVERSAL: 'payoutBankReversal',
};

export const correctionSettlementOrderReasonTypesTranslate = {
	[correctionSettlementOrderReasonTypes.NEGATIVE_AMOUNT_BOOTH_OWNER_ACCOUNT]: 'Negativt beløb på standholder konto',
	[correctionSettlementOrderReasonTypes.MANUAL]: 'Manuel korrektion',
	[correctionSettlementOrderReasonTypes.PAYOUT_BANK_REVERSAL]: 'Tilbageført bankudbetaling',
};

export default correctionSettlementOrderReasonTypes;
